module.exports = __webpack_public_path__ + "static/img/userdefalute.c4debf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userdefalute.jpg
// module id = q9uQ
// module chunks = 109